import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import Iconify from "minimals-template/components/Iconify"
import { useCreateRateCard } from "./use-create-rate-card"
import illustrationSrc from "./rate_card_empty.svg"

export function RateCardsEmpty({ status, archivedCount, onViewArchived, onViewActive, canManageOptimiser }) {
    const handleCreate = useCreateRateCard()
    // Archived filter with no archived items: offer a way back to Active rather than the "create your first" state
    const isArchivedView = status === "archived"
    const archivedNoun = archivedCount === 1 ? "item" : "items"

    return (
        <Stack data-cy="rate-cards-empty" alignItems="center" justifyContent="center" spacing={2} sx={{ py: 4 }}>
            <Box component="img" src={illustrationSrc} sx={{ width: 275, height: 200 }} />
            <Stack spacing={0.5} alignItems="center">
                <Typography variant="h6">
                    <If value={isArchivedView}>
                        No archived rate cards
                        <Else>No rate cards yet</Else>
                    </If>
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, textAlign: "center" }}>
                    <If value={isArchivedView}>
                        There are no archived rate cards.
                        <Else>
                            Set hourly rates per trade to calculate regime costs accurately across your scenarios
                        </Else>
                    </If>
                </Typography>
            </Stack>
            <If value={isArchivedView}>
                <Button variant="outlined" startIcon={<Iconify icon="mdi:arrow-left" />} onClick={onViewActive}>
                    Back to Active
                </Button>
                <Else>
                    <If value={canManageOptimiser}>
                        <Button variant="contained" startIcon={<Iconify icon="mdi:plus" />} onClick={handleCreate}>
                            Create Rate Card
                        </Button>
                    </If>
                    <If value={archivedCount > 0}>
                        <Typography variant="body2" color="text.secondary">
                            You have {archivedCount} archived {archivedNoun}
                            {" - "}
                            <Link component="button" variant="body2" onClick={onViewArchived}>
                                view archived
                            </Link>
                        </Typography>
                    </If>
                </Else>
            </If>
        </Stack>
    )
}
